<template>
  
  <div id="full">
    <div id="overlay">
      
      <div id="text">
        <a class='contact' href="tel:9714275943"><b-icon icon="phone"></b-icon> : Call</a><br>
        
        <a class='contact' href="mailto:yunus.ujjaini52@gmail.com"><b-icon icon="chat-fill"></b-icon> : Email</a><br>
        <br><br><br><b-icon  @click="off" icon="X"></b-icon>
      </div>
    </div>
    <!-- As a heading -->
      <svg id="theSVG" style="margin-top:0px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#18A2B8" fill-opacity="1" d="M0,128L120,112C240,96,480,64,720,74.7C960,85,1200,139,1320,165.3L1440,192L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path></svg>
      <b-jumbotron bg-variant="info" text-variant="white"  style='border-radius:0px; border-bottom:none; margin-bottom:0px; margin-top:-5px;'>
        <template v-slot:header ><h1 class="myBanner">Hey There! I am Manan<span class="wave">👋</span></h1></template>

        <template v-slot:lead>
          <div class="typewriter">
              <div class="typewriter-text">Let's put a design to your idea.</div>
          </div>
        </template>

        <hr class="my-4">

        <b-button variant="outline-dark btn-lg" style="color:white;" @click="on">Contact Me </b-button>
      </b-jumbotron>
      
  </div>
  
</template>

<script>
export default {
  methods:{
     on:function() {
      document.getElementById("overlay").style.display = "block";
    },
      off:function() {
        document.getElementById("overlay").style.display = "none";
      } ,
  }

}
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}
#theSVG{
    transform: rotate(180deg);

  }
.typewriter {
    font-family: Courier, monospace;
    display: inline-block;
  }

.typewriter-text {
    display: inline-block;
    overflow: hidden;
    letter-spacing: 1px;
    animation: typing 5s steps(30, end), blink .75s step-end infinite;
    white-space: nowrap;
    font-size: 15px;
    font-weight: 700;
    border-right: 4px solid orange;
    box-sizing: border-box;
}

@keyframes typing {
    from { 
        width: 0% 
    }
    to { 
        width: 100% 
    }
}

@keyframes blink {
    from, to { 
        border-color: transparent 
    }
    50% { 
        border-color: orange; 
    }
}
.contact{
  color:white;
  font-size: 50%;
}
.contact:hover{
  text-decoration: none;
}
#full{
      margin-top:-40px;
    }
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.9); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
#text{
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
}
  span.wave {
  animation-name: wave-animation;
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  transform-origin: 70% 70%;
  display: inline-block;
}
@keyframes wave-animation {
    0% { transform: rotate(  0.0deg); }
   10% { transform: rotate(-10.0deg); }
   20% { transform: rotate( 12.0deg); }
   30% { transform: rotate(-10.0deg); }
   40% { transform: rotate(  9.0deg); }
   50% { transform: rotate(  0.0deg); }
  100% { transform: rotate(  0.0deg); }
}
.myBanner{
  font-size: 50%;
}
@media only screen and (min-width: 768px) {
  /* For desktop: */
    span.wave {
      animation-name: wave-animation;
      animation-duration: 2.5s;
      animation-iteration-count: infinite;
      transform-origin: 70% 70%;
      display: inline-block;
    }
    @keyframes wave-animation {
      0% { transform: rotate(  0.0deg); }
      10% { transform: rotate(-10.0deg); }
      20% { transform: rotate( 12.0deg); }
      30% { transform: rotate(-10.0deg); }
      40% { transform: rotate(  9.0deg); }
      50% { transform: rotate(  0.0deg); }
      100% { transform: rotate(  0.0deg); }
    }
    .myBanner{
      font-size: 80%;
    }
    .contact{
      color:white;
      font-size: 90%;
    }
    .typewriter-text {
      display: inline-block;
      overflow: hidden;
      letter-spacing: 1px;
      animation: typing 5s steps(30, end), blink .75s step-end infinite;
      white-space: nowrap;
      font-size: 30px;
      font-weight: 700;
      border-right: 4px solid orange;
      box-sizing: border-box;
    }
    #full{
      margin-top:-180px;
    }
  }
    



</style>
